/**
 * Bilingual content helpers.
 *
 * The backend stores localized fields as { es: string, en: string }.
 * Legacy values may still be plain strings — pickI18n handles both transparently.
 */

export const pickI18n = (value, lang = 'es') => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value; // legacy
  if (typeof value === 'object') {
    const v = value[lang];
    if (v) return v;
    // fallback: ES, then EN, then any non-empty
    return value.es || value.en || '';
  }
  return String(value);
};

/** Returns a clean {es, en} structure */
export const normalizeI18n = (value) => {
  if (value === null || value === undefined) return { es: '', en: '' };
  if (typeof value === 'string') return { es: value, en: '' };
  return { es: value.es || '', en: value.en || '' };
};

/** Returns true if both translations are filled */
export const isFullyTranslated = (value) => {
  const n = normalizeI18n(value);
  return !!(n.es && n.en);
};

/** Map a list of strings/objects to array of {es,en} */
export const normalizeI18nList = (arr) => (arr || []).map(normalizeI18n);
